var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.24998L0.75 9.95831C0.75 11.1319 1.70139 12.0833 2.875 12.0833L9.95833 12.0833C11.1319 12.0833 12.0833 11.1319 12.0833 9.95831L12.0833 9.24998M9.25 3.58331L6.41667 0.74998M6.41667 0.74998L3.58333 3.58331M6.41667 0.74998L6.41667 9.24998",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UploadBtn.184c657416570039b4774be4e0902a20.svg";